var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"color":"primary lighten-1","padless":""}},[_c('v-row',{attrs:{"justify":"center","no-gutters":""}},[_c('v-col',{staticClass:"primary lighten-2 py-4 text-center white--text",attrs:{"cols":"12"}},[_vm._v(" "+_vm._s(new Date().getFullYear())+" — "),_c('strong',[_vm._v(_vm._s(_vm.name))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }